import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";
import {Observable} from 'rxjs';
import {catchError} from "rxjs/operators";
import {handleError} from "../util/error-util";
import {DatePipe} from "@angular/common";
import {TipoUpload} from "./tipo-upload";
import {parseArguments} from "@angular/cli/models/parser";

@Injectable({
  providedIn: 'root'
})
export class ImportacaoLoteService {

  urlUpload = '/upload/async';

  url = '/importacao';

  private readonly dateFormat = 'yyyy-MM-dd';

  private readonly _httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(
    private httpClient: HttpClient,
    private readonly datePipe: DatePipe
  ) {
  }

  importar(file: File, tipo: TipoUpload): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append("tipo", TipoUpload[tipo])
    return this.httpClient.post<any>(`${this.urlUpload}`,formData).pipe(catchError(handleError));
  }


  search(model: any, tipo: TipoUpload, pageSize: number): Observable<any> {
    const headers = this._httpHeaders;
    let params: HttpParams = new HttpParams();
    Object.keys(model).forEach(item => {
      if (this.notNullNotEmpty(model[item])) params = params.set(item, model[item])
    });

    if (this.notNullNotEmpty(model.fileName)) {
      params = params.set("fileName", model.fileName);
    }
    if (this.notNullNotEmpty(model.usuario)) {
      params = params.set("usuario", model.usuario);
    }
    if (this.notNullNotEmpty(model.status)) {
      params = params.set("status", model.status);
    }

    if (model.inicio) {
      params = params.set('de', this.datePipe.transform(model.inicio, this.dateFormat));
    }
    if (model.fim) {
      params = params.set('ate', this.datePipe.transform(model.fim, this.dateFormat));
    }
    params = params.set('tipo',TipoUpload[tipo])

    params = params.set('size', pageSize.toString());
    params = params.set("page", model.page);
    params = params.set("sort", "inicio,DESC");
    const options = {headers, params};

    return this.httpClient.get<any[]>(`${this.url}/log/`, options).pipe(catchError(handleError));
  }

  downloadStack(identificador: string): Observable<HttpResponse<ArrayBuffer>> {
    return this.httpClient
    .get<ArrayBuffer>(`${this.url}/batch/stack/${identificador}`, {observe: 'response', responseType: 'blob' as 'json'})
    .pipe(catchError(handleError));
  }

  downloadXLSXCompleto(identificador: string): Observable<HttpResponse<ArrayBuffer>> {
    return this.httpClient
    .get<ArrayBuffer>(`${this.url}/batch/download/completo/${identificador}`, {observe: 'response', responseType: 'blob' as 'json'})
    .pipe(catchError(handleError));
  }

  notNullNotEmpty(value: any): boolean {
    return value !== null && value !== "" && value !== undefined;
  }
}

